// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".exc-text-with-dots[data-v-f678236c]{overflow:hidden;max-width:100%;display:flex}.exc-text-with-dots__value[data-v-f678236c]{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
